import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { init } from "@datadog/ui-extensions-sdk"

Vue.config.productionTip = false
Vue.prototype.$client = init()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
